var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Slider from '@teliaee/react-slick';
import Button from '@telia-front/button';
import CloseButton from '@telia-front/close-button';
import { getBackgroundColorClass } from '@telia-front/colors';
import Container from '@telia-front/container';
import { getParameterByName } from '@telia-front/helper';
import Image from '@telia-front/image';
import { useLabels } from '@telia-front/label-provider';
import ObjectFit from '@telia-front/object-fit';
import Video from '@telia-front/video';
const Section = (props) => {
    const labels = useLabels();
    return React.createElement(SectionInner, Object.assign({}, props, { labels: labels }));
};
export default Section;
class SectionInner extends React.Component {
    constructor(props) {
        super(props);
        this.slick = null;
        this.getBackground = (image) => (React.createElement(ObjectFit, { fit: this.props.backgroundFit || 'cover', positionX: "center", positionY: this.props.backgroundFit === 'contain' ? 'top' : 'center' },
            React.createElement(Image, Object.assign({}, image, { className: "section__background-image", pictureClassName: "section__background-picture", width: 500 }))));
        this.getVideo = (video) => (React.createElement(Video, Object.assign({}, video, { defaultPlaying: true, hideWithoutConsent: true, className: "section__background-video", hideOverview: true })));
        this.state = {
            firstSlideKey: null,
            isMounted: false,
            nextSlideIndex: 0,
            prevSlideIndex: 0,
            autoplay: true,
        };
    }
    componentDidMount() {
        this.setState({
            isMounted: true,
        });
        if (this.props.urlParameter) {
            const urlParameter = getParameterByName(this.props.urlParameter);
            if (urlParameter && urlParameter.length) {
                this.setState({
                    firstSlideKey: urlParameter,
                });
            }
        }
    }
    CSS() {
        const styleEntities = {};
        if (this.props.minHeight) {
            styleEntities.minHeight = `${this.props.minHeight}px`;
        }
        return styleEntities;
    }
    isCustomColor(color) {
        return typeof color === 'object';
    }
    get background() {
        const { backgroundColor, theme } = this.props;
        if (backgroundColor && !this.isCustomColor(backgroundColor)) {
            return backgroundColor;
        }
        if (theme) {
            return 'neutral-bg-level-1';
        }
        return;
    }
    get bottomPadding() {
        const { bottomPadding, pullBottom } = this.props;
        if (bottomPadding) {
            return bottomPadding;
        }
        if (typeof pullBottom === 'boolean' && pullBottom) {
            return 'large';
        }
        return;
    }
    BEM() {
        const classArray = ['section'];
        if (this.background) {
            classArray.push(getBackgroundColorClass(this.background));
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.isFull) {
            classArray.push('section--full');
        }
        if (this.bottomPadding) {
            classArray.push('section--bottom-padding-' + this.bottomPadding);
        }
        if (typeof this.props.pullTop === 'string') {
            classArray.push('section--pull-top-' + this.props.pullTop);
        }
        else if (this.props.pullTop) {
            classArray.push('section--pull-top');
        }
        if (typeof this.props.pullBottom === 'string') {
            classArray.push('section--pull-bottom-' + this.props.pullBottom);
        }
        else if (this.props.pullBottom) {
            classArray.push('section--pull-bottom');
        }
        if (this.props.backgroundFit) {
            classArray.push('section--background-' + this.props.backgroundFit);
        }
        if (this.props.smallScreenImagePosition === 'above') {
            classArray.push('section--small-screen-image-above');
        }
        if (this.props.minHeight) {
            classArray.push('section--has-min-height');
        }
        return classArray.join(' ');
    }
    sectionBackgroundBEM() {
        const classArray = ['section__background'];
        if (this.props.backgroundVideo && !this.props.backgroundImage) {
            classArray.push('has-video');
        }
        if (this.props.backgroundVideo && this.props.backgroundImage) {
            classArray.push('has-video-and-image');
        }
        return classArray.join(' ');
    }
    getCarouselOptions() {
        return {
            afterChange: () => {
                this.setState({
                    prevSlideIndex: null,
                });
            },
            arrows: false,
            autoplay: true,
            autoplaySpeed: 8000,
            beforeChange: ({}, nextSlide) => {
                if (this.state.nextSlideIndex !== nextSlide) {
                    this.setState(prevState => ({
                        nextSlideIndex: nextSlide,
                        prevSlideIndex: prevState.nextSlideIndex,
                    }));
                }
            },
            dots: false,
            draggable: false,
            easing: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
            fade: true,
            pauseOnHover: false,
            speed: 500,
            waitForAnimate: false,
        };
    }
    sortCarouselChildren() {
        if (this.state.isMounted && this.props.carousel) {
            return this.props.carousel.sort((x, y) => {
                return x.key === this.state.firstSlideKey ? -1 : y.key === this.state.firstSlideKey ? 1 : 0;
            });
        }
        return this.props.carousel || [];
    }
    carouselItemBEM(modifiers) {
        const classArray = ['section__carousel-item'];
        if (modifiers.isCurrent) {
            classArray.push('is-current');
        }
        if (modifiers.isPrev) {
            classArray.push('is-prev');
        }
        if (modifiers.isNext) {
            classArray.push('is-next');
        }
        if (modifiers.isPrevCurrent) {
            classArray.push('is-prev-current');
        }
        return classArray.join(' ');
    }
    getCarouselChildren() {
        return this.sortCarouselChildren().map((item, index) => {
            const { key } = item, imageProps = __rest(item, ["key"]);
            const modifiers = {
                isCurrent: index === this.state.nextSlideIndex,
                isNext: index > this.state.nextSlideIndex,
                isPrev: index < this.state.nextSlideIndex,
                isPrevCurrent: index === this.state.prevSlideIndex && index !== this.state.nextSlideIndex,
            };
            return (React.createElement("div", { key: index, className: this.carouselItemBEM(modifiers) }, this.getBackground(imageProps)));
        });
    }
    getCloseButton() {
        var _a;
        const handleClick = (event) => {
            var _a;
            if ((_a = this.props.closeButton) === null || _a === void 0 ? void 0 : _a.onClick) {
                this.props.closeButton.onClick(event);
            }
        };
        const classArray = ['section__close-button'];
        if ((_a = this.props.closeButton) === null || _a === void 0 ? void 0 : _a.className) {
            classArray.push(this.props.closeButton.className);
        }
        return React.createElement(CloseButton, Object.assign({}, this.props.closeButton, { onClick: handleClick, className: classArray.join(' ') }));
    }
    getCarousel() {
        const handleCarouselAutoplay = () => {
            var _a, _b;
            this.setState(prevState => ({
                autoplay: !prevState.autoplay,
            }));
            if (this.state.autoplay) {
                (_a = this.slick) === null || _a === void 0 ? void 0 : _a.slickPause();
            }
            else {
                (_b = this.slick) === null || _b === void 0 ? void 0 : _b.slickPlay();
            }
        };
        const children = this.getCarouselChildren();
        const shouldUseSlick = this.state.isMounted && React.Children.count(children) > 1;
        const carouselButtonBEM = () => {
            var _a, _b;
            const classArray = ['section__carousel-button'];
            if ((_a = this.props.carouselButton) === null || _a === void 0 ? void 0 : _a.locationBigScreen) {
                classArray.push(`section__carousel-button--${this.props.carouselButton.locationBigScreen}`);
            }
            if ((_b = this.props.carouselButton) === null || _b === void 0 ? void 0 : _b.locationSmallScreen) {
                classArray.push(`section__carousel-button--mobile-${this.props.carouselButton.locationSmallScreen}`);
            }
            return classArray.join(' ');
        };
        return (React.createElement(React.Fragment, null, shouldUseSlick ? (React.createElement(React.Fragment, null,
            React.createElement(Slider, Object.assign({ ref: e => (this.slick = e), className: "section__carousel" }, (shouldUseSlick && this.getCarouselOptions())), children),
            this.props.carouselButton && (React.createElement("div", { className: "section__carousel-inner" },
                React.createElement(Container, { className: "section__carousel-inner-container" },
                    React.createElement(Button, { text: this.state.autoplay ? this.props.labels.get('pause') : this.props.labels.get('play'), icon: this.state.autoplay ? '#pause' : '#play', onClick: () => handleCarouselAutoplay(), size: "small", className: carouselButtonBEM() })))))) : (React.createElement("div", { className: "section__carousel" }, children))));
    }
    get backgroundColorStyle() {
        if (this.props.backgroundColor && this.isCustomColor(this.props.backgroundColor)) {
            return { background: this.props.backgroundColor.color };
        }
        return {};
    }
    render() {
        return (React.createElement("section", { className: this.BEM(), style: this.backgroundColorStyle, "aria-labelledby": this.props['aria-labelledby'], "data-theme": this.props.theme },
            React.createElement("div", { className: "section__inner", style: this.CSS() },
                React.createElement("div", { className: this.sectionBackgroundBEM() },
                    this.props.backgroundImage && this.getBackground(this.props.backgroundImage),
                    this.props.backgroundVideo && this.getVideo(this.props.backgroundVideo)),
                this.props.carousel && this.getCarousel(),
                this.props.closeButton && this.getCloseButton(),
                React.createElement("div", { className: "section__content" }, this.props.children))));
    }
}
SectionInner.defaultProps = {
    urlParameter: 'landing',
    smallScreenImagePosition: 'background',
};
